import { useEffect, useState } from 'react';
import { ethers } from 'ethers';
import { useWallet } from '../context/WalletContext';
import { useContracts } from './useContracts';
import { CONTRACT_ADDRESSES } from '../config/contracts';

export const useUSDT = (refreshKey = 0) => {
  const { account } = useWallet();
  const { usdt } = useContracts();
  const [balance, setBalance] = useState(ethers.BigNumber.from(0));
  const [allowance, setAllowance] = useState(ethers.BigNumber.from(0));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!account || !usdt?.read || !CONTRACT_ADDRESSES.PLANS) {
        setBalance(ethers.BigNumber.from(0));
        setAllowance(ethers.BigNumber.from(0));
        return;
      }
      setLoading(true);
      try {
        const [b, a] = await Promise.all([
          usdt.read.balanceOf(account),
          usdt.read.allowance(account, CONTRACT_ADDRESSES.PLANS)
        ]);
        if (!cancelled) {
          setBalance(b);
          setAllowance(a);
        }
      } catch (e) {
        if (!cancelled) {
          setBalance(ethers.BigNumber.from(0));
          setAllowance(ethers.BigNumber.from(0));
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [account, usdt, refreshKey]);

  const approveMax = async () => {
    if (!usdt?.write || !CONTRACT_ADDRESSES.PLANS) throw new Error('Wallet not ready');
    const tx = await usdt.write.approve(CONTRACT_ADDRESSES.PLANS, ethers.constants.MaxUint256);
    await tx.wait();
    return tx;
  };

  const approveAmount = async (amount) => {
    if (!usdt?.write || !CONTRACT_ADDRESSES.PLANS) throw new Error('Wallet not ready');
    const tx = await usdt.write.approve(CONTRACT_ADDRESSES.PLANS, amount);
    await tx.wait();
    return tx;
  };

  return { balance, allowance, loading, approveMax, approveAmount };
};
